module.exports = __webpack_public_path__ + "img/share-arrow.b2fe39a4.png";